import PreloadImage from '../../../../components/PreloadImage/PreloadImage';
import { Label } from "../../../../components/texts/label";
import { Text } from "../../../../components/texts/text";
import Title from "../../../../components/texts/title";
import { _colorText, _size, _sizeHeading, _sizeText, _typeLabel } from "../../../../core/core";
import { useOrder } from '../../../../entities/order/context/OrderContext';
import "./PaymentMorda.css";


export const PaymentMorda = ({ children }: { children: React.ReactNode }) => {

    const { service } = useOrder()
    if (!service) {
        return null
    }
    return (
        <div className="morda">
            <div className="morda-preview">
                <PreloadImage
                    imageSrc={service.base_info.image}
                    alt={`${service.base_info.breadlink_name} картинка`}
                    className={"m-img "}
                ></PreloadImage>
                <div className="morda-preview-body">
                    <div className="morda-preview-body-text">
                        <Title type={_sizeHeading.h2_2} is_h1 color={_colorText.default}>{service.morda.title}</Title>
                        <Text size={_sizeText.s} color={_colorText.neutral}>{service.morda.description}</Text>
                    </div>
                    <div className="morda-preference">
                        {service.morda.preferences.map((preference, index) => (
                            <Label key={index} type={_typeLabel.secondary} size={_size.XS}>{preference.text}</Label>
                        ))}
                    </div>
                </div>
            </div>
            {children}
        </div>
    )
}   